import React from "react";
import { Redirect } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Constants, Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import Avatar from "./common/WelcomeAvatarImg";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledH2 = styled.h2`
  font-size: 18px;
`;

class Welcome extends BaseComponent {
  constructor() {
    super();
    this.state = {
      consumer: null,
      showLoader: false,
    };
  }

  async componentDidMount() {
    this.setState({ showLoader: true });
    const response = await this.safeFunApi.getCurrentUser();
    this.setState({ consumer: response.data, showLoader: false });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Welcome" />
        <SFLoader active={this.state.showLoader} />
        <MainContentWrapper>
          <Avatar />
          <Wrapper>
            <Grid columns={1} style={{ width: "400px" }}>
              <Grid.Row>
                <Grid.Column>
                  <StyledH2>
                    Welcome to SafeFun,{" "}
                    {this.state.consumer ? this.state.consumer.safeFunId : null}
                    !
                  </StyledH2>

                  <p>
                    We help you get back to living through COVID-19 testing. The
                    way it works is really simple. Once you receive your test
                    results, you just upload them here and we'll validate the
                    results and you're ready to go.
                  </p>

                  <StyledH2>How long does a test give me?</StyledH2>

                  <p>
                    That depends upon a few factors.{" "}
                    <a href={Constants.TESTING_URL}>Click here</a> to learn more
                    about out testing philosophy and SafeWindows.
                  </p>

                  <StyledH2>Share with Friends</StyledH2>

                  <p>
                    You can easily share your SafeWindow with friends right in
                    the app. Friends can find you using your name, email or your
                    SafeFun ID -{" "}
                    {this.state.consumer ? this.state.consumer.safeFunId : null}
                    .
                  </p>

                  <StyledH2>Ready to get started?</StyledH2>

                  <p>
                    Click Continue below to add your first test result and get
                    back to living.
                  </p>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <CenteredButtonWrapper>
                    <PillButton
                      primary
                      onClick={() => {
                        this.setState({ redirectPath: Paths.SAFE_WINDOW });
                      }}
                      style={{ width: "200px" }}
                    >
                      Continue
                    </PillButton>
                  </CenteredButtonWrapper>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default Welcome;
